import config from "./config";

export function init(themeRegistry) {
  themeRegistry.register("default", {config});
}
